import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLoading } from "../../../../features/bookings/transferSlice";
import Loader from "../../../../helpers/Loader";
import { infoToast } from "../../../../helpers/toaster";
import DetailList from "./DetailList";
import JourneyDetails from "./JourneyDetails";
import TravellerDetail from "./TravellerDetail";

const TransferDetails = () => {

  const userData = sessionStorage.getItem("userData")!==undefined && JSON.parse(sessionStorage.getItem("userData"))
  // useSelector((state) => state.user.userData, shallowEqual);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (userData === null) {
      navigate("/transfer");
      infoToast("Please login First!")
    }
  }, [userData]);

  const loading = useSelector(getLoading);
  if (loading) {
    return <Loader />;
  }

if(userData!==null){
  return (
    <>
      <section style={{ padding: "50px 0px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <DetailList />
              <TravellerDetail />
            </div>
            <div className="col-lg-4">
              <JourneyDetails />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
 
};

export default TransferDetails;
